/**
 * 화면 아래 고정된 생성기의 위치·하단 여백 — useVisualViewportInset 이 싣는 값을 쓴다.
 * 하단 여백은 Figma 5-1 · 6-5 「만드는 중」 기준 PC 24px · 모바일 16px(+ safe-area), 키보드가 열리면 8px.
 *
 * - 키보드 열림/닫힘 여백은 서로 배타적인 선택자로만 건다. 둘이 같은 요소에 동시에 걸리면 어느 쪽이
 *   이길지가 Tailwind 의 variant 생성 순서에 달려, 순서가 바뀌면 조용히 깨진다.
 * - 클래스는 반드시 통째로 적는다. Tailwind 는 소스에 그대로 적힌 문자열만 CSS 로 만들어, 템플릿으로
 *   조합한 클래스는 아무 경고 없이 빠진다.
 * 둘 다 aiGenerateDockInset.const.test 가 이 파일을 실제로 스캔해 지킨다.
 */
export const AI_GENERATE_DOCK_FIXED_INSET_CLASS = [
  'fixed inset-x-0 bottom-[var(--visual-viewport-bottom,0px)]',
  '[&:not([data-keyboard=open])]:pb-[calc(16px+env(safe-area-inset-bottom,0px))]',
  '[&:not([data-keyboard=open])]:tablet-sm:pb-[calc(24px+env(safe-area-inset-bottom,0px))]',
  // PRD 6-6 「입력창이 키보드 바로 위(간격 8)」
  'data-[keyboard=open]:pb-[8px]',
].join(' ');

/** 흐름 안에 둘 때(스토리북·테스트) — 키보드 보정 없이 기본 여백만. */
export const AI_GENERATE_DOCK_STATIC_INSET_CLASS =
  'relative pb-[calc(16px+env(safe-area-inset-bottom,0px))] tablet-sm:pb-[calc(24px+env(safe-area-inset-bottom,0px))]';
